import {GetterTree} from 'vuex';
import {RootState} from '@/store';
import {AuthorizationState} from '@/store/modules/authorization';
import { ACCESS_TOKEN, REFRESH_TOKEN, REFRESHING_TOKEN, TEMPORARY_ACCESS_TOKEN } from '@/types/authorization.types';

export const getters: GetterTree<AuthorizationState, RootState> = {

  [ACCESS_TOKEN](state): string | null {
    return state.accessToken;
  },

  [REFRESH_TOKEN](state): string | null {
    return state.refreshToken;
  },

  [REFRESHING_TOKEN](state): boolean {
    return state.refreshingToken;
  },

  [TEMPORARY_ACCESS_TOKEN](state): string | null {
    return state.temporaryAccessToken;
  },

};
